import React, {useImperativeHandle, forwardRef} from 'react'
import PropTypes from 'prop-types'
import {Stack, Box, Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {useForm} from 'react-hook-form'
import Field from '../../field'
import useGiftCardFields from '../../forms/useGiftCardFields'

const GiftCardForm = forwardRef(({isVisible = false, headingIndex = 4}, ref) => {
    const form = useForm({
        defaultValues: {
            yourName: '',
            recipientName: '',
            recipientEmail: '',
            confirmRecipientEmail: '',
            message: ''
        }
    })

    const fields = useGiftCardFields({
        form,
        prefix: ''
    })

    const messageValue = form.watch('message')

    // Expose validation functions to parent
    useImperativeHandle(
        ref,
        () => ({
            validate: async () => {
                const result = await form.trigger()
                return result
            },
            getFormState: () => form.formState,
            getValues: () => form.getValues(),
            isValid: () => form.formState.isValid,
            reset: () => form.reset()
        }),
        [form]
    )

    if (!isVisible) {
        return null
    }

    return (
        <Box className="gift-card-form">
            <Box marginBottom={2} textStyle={'bodyXsRegular'}>
                <FormattedMessage
                    id="gift_card_form.heading.personalise"
                    defaultMessage="Personalise"
                />
            </Box>
            <Stack spacing={4} align="stretch">
                <Flex direction={{base: 'column'}} gap={{base: 3}}>
                    <Box flex="1">
                        <Field {...fields.recipientEmail} />
                    </Box>
                    <Box flex="1">
                        <Field {...fields.confirmRecipientEmail} />
                    </Box>
                </Flex>

                <Flex direction={{base: 'column'}} gap={{base: 3}}>
                    <Box flex="1">
                        <Field {...fields.recipientName} />
                    </Box>
                    <Box flex="1">
                        <Field {...fields.yourName} />
                    </Box>
                </Flex>

                <Box>
                    <Text textAlign="right" textStyle="bodyXsRegular" color="webTypo.textSecondary" mb={1}>
                        {(messageValue || '').length}/{fields.message.maxLength}
                    </Text>
                    <Field {...fields.message} />
                </Box>
            </Stack>
        </Box>
    )
})

GiftCardForm.displayName = 'GiftCardForm'

GiftCardForm.propTypes = {
    isVisible: PropTypes.bool,
    headingIndex: PropTypes.number
}

export default GiftCardForm
